export const LAUNCHER_COLLAPSED_SIZE = 56;

export const LAUNCHER_COLLAPSED_SIZE_MOBILE = 48;

export const LAUNCHER_ICON_SIZE = 36;

export const LAUNCHER_OFFSET = 24;

export const LAUNCHER_OFFSET_MOBILE = 16;

export const LAUNCHER_EXPAND_DURATION_MS = 180;

export const LAUNCHER_SHADOW_OPACITY = 0.35;

export const LAUNCHER_SHADOW_HOVER_OPACITY = 0.45;

export const UNREAD_LABEL_SINGULAR = '1 new suggestion';

export const UNREAD_LABEL_PLURAL_TEMPLATE = '{count} new suggestions';

export const DEFAULT_SUBLABEL = 'Ask about this loan';
